// extracted by mini-css-extract-plugin
module.exports = {"textblock":"CMSTextBlock_textblock__bUUXk"};